import Lottie from 'lottie-react';
import { Link } from 'react-router-dom';
import pagenotfound from "../components/Common/animationJson/pagenotfound.json";

function PageNotFound() {
  return (
    <div className="py-14 px-4 md:px-6 2xl:px-20 2xl:container 2xl:mx-auto bg-white">
      <div className="flex justify-center item-center flex-col text-center">
        <div className="flex justify-center items-center">
          <Lottie animationData={pagenotfound} loop={true} animationDelay={1500} autoplay={true} className="w-72" />
        </div>
        <h1 className="text-xl lg:text-3xl font-semibold text-gray-900 capitalize">Page Not Found!</h1>
        <p className="my-5 text-base text-gray-600 capitalize w-full">We're sorry, the page you requested could not be found</p>
        <Link to="/" className="w-40 mx-auto py-3 rounded-md border-[1px] bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:border-indigo-100 text-base font-medium text-white shadow-md" style={{ borderColor: "#0000" }}>Go To Homepage</Link>
      </div>
    </div>
  );
}

export default PageNotFound;